module.exports = __webpack_public_path__ + "static/media/icon_share.79821518.svg";